<script>
    export let itemliststock = [];
    import { executeClient } from "api/rage";
    import { itemsInfo } from 'json/itemsInfo.js'
    import { getPng } from './getPng.js'
    import { onMount } from 'svelte';

    let sortedItems = [];
    let loading = true;
    let error = false;
    let menuVisible = true;

    onMount(() => {
        // Принудительно показываем меню
        menuVisible = true;
        
        // Проверяем данные при монтировании
        if (itemliststock && itemliststock.length > 0) {
            processItems();
        } else {
            // Запрашиваем данные если их нет
            executeClient("client.stockitems");
            setTimeout(() => {
                if (!itemliststock || itemliststock.length === 0) {
                    error = true;
                }
                loading = false;
            }, 1000);
        }
    });

    // Реактивное обновление при изменении itemliststock
    $: {
        if (itemliststock && itemliststock.length > 0) {
            processItems();
        }
    }

    function processItems() {
        try {
            sortedItems = itemliststock
                .filter(item => item && item.ItemId) // Убираем невалидные предметы
                .sort((a, b) => a.SqlId - b.SqlId);
            loading = false;
            error = false;
            console.log('Items loaded:', sortedItems.length);
        } catch (e) {
            console.error('Error processing items:', e);
            error = true;
        }
    }

    const takeItem = (item) => {
        if (!item || !item.Index) return;
        
        // Блокируем повторные нажатия
        const btn = event.currentTarget;
        btn.style.pointerEvents = 'none';
        btn.style.opacity = '0.5';
        
        // Забираем предмет
        executeClient("client.gamemenu.inventory.stack", "other", item.Index, 2, 1);
        
        // Обновляем список через небольшую задержку
        setTimeout(() => {
            executeClient("client.stockitems");
            
            // Возвращаем кнопку в нормальное состояние
            setTimeout(() => {
                btn.style.pointerEvents = 'auto';
                btn.style.opacity = '1';
            }, 500);
        }, 100);
    }

    const closeMenu = () => {
        menuVisible = false;
        executeClient("client.hideMenu"); // Отправляем сигнал на скрытие меню
    }

    // Обработчик клика вне меню для закрытия
    function handleOverlayClick(e) {
        if (e.target.classList.contains('menu-overlay')) {
            closeMenu();
        }
    }
</script>

{#if menuVisible}
    <!-- Затемненный фон для закрытия по клику -->
    <div class="menu-overlay" on:click={handleOverlayClick}>
        <!-- Основное меню -->
        <div class="stock-menu" on:click|stopPropagation>
            <div class="menu-header">
                <h2>Хранилище</h2>
                <button class="close-btn" on:click={closeMenu}>×</button>
            </div>
            
            <div class="items-container">
                {#if loading}
                    <div class="loading">
                        <div class="spinner"></div>
                        <p>Загрузка предметов...</p>
                    </div>
                {:else if error}
                    <div class="error">
                        <p>Ошибка загрузки предметов</p>
                        <button class="retry-btn" on:click={() => {
                            loading = true;
                            error = false;
                            executeClient("client.stockitems");
                            setTimeout(() => {
                                if (!itemliststock || itemliststock.length === 0) {
                                    error = true;
                                }
                                loading = false;
                            }, 1000);
                        }}>
                            Повторить
                        </button>
                    </div>
                {:else if sortedItems.length === 0}
                    <div class="empty">
                        <p>В хранилище пусто</p>
                    </div>
                {:else}
                    {#each sortedItems as item (item.SqlId)}
                        <div class="item-card">
                            <div class="item-count">{item.Count || 1}</div>
                            <img 
                                src={getPng(item, itemsInfo[item.ItemId])} 
                                alt={itemsInfo[item.ItemId]?.Name || 'Предмет'}
                                on:error={(e) => {
                                    e.target.src = 'default-item.png'; // Заглушка для отсутствующих изображений
                                }}
                            />
                            <div class="item-name">
                                {itemsInfo[item.ItemId]?.Name || 'Неизвестный предмет'}
                            </div>
                            <button 
                                class="take-btn" 
                                on:click={(e) => takeItem(item, e)}
                            >
                                Забрать
                            </button>
                        </div>
                    {/each}
                {/if}
            </div>
        </div>
    </div>
{/if}

<style>
    .menu-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.7);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1000;
        pointer-events: auto;
    }

    .stock-menu {
        width: 800px;
        max-width: 90vw;
        max-height: 80vh;
        background: #1a1a1a;
        border-radius: 8px;
        box-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
        display: flex;
        flex-direction: column;
        pointer-events: auto;
        animation: slideIn 0.2s ease;
    }

    @keyframes slideIn {
        from {
            transform: translateY(-20px);
            opacity: 0;
        }
        to {
            transform: translateY(0);
            opacity: 1;
        }
    }

    .menu-header {
        padding: 15px 20px;
        background: #2a2a2a;
        border-radius: 8px 8px 0 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 2px solid #3a3a3a;
    }

    .menu-header h2 {
        margin: 0;
        color: #fff;
        font-size: 20px;
    }

    .close-btn {
        background: none;
        border: none;
        color: #fff;
        font-size: 28px;
        cursor: pointer;
        padding: 0 8px;
        line-height: 1;
        transition: color 0.2s;
    }

    .close-btn:hover {
        color: #ff4444;
    }

    .items-container {
        padding: 20px;
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
        gap: 15px;
        overflow-y: auto;
        max-height: calc(80vh - 70px);
    }

    .item-card {
        background: #2a2a2a;
        border-radius: 6px;
        padding: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
        transition: transform 0.2s, box-shadow 0.2s;
        border: 1px solid #3a3a3a;
    }

    .item-card:hover {
        transform: translateY(-2px);
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
        border-color: #4a4a4a;
    }

    .item-count {
        position: absolute;
        top: 5px;
        right: 5px;
        background: #ff4444;
        color: white;
        border-radius: 12px;
        padding: 2px 8px;
        font-size: 12px;
        font-weight: bold;
        min-width: 20px;
        text-align: center;
    }

    .item-card img {
        width: 60px;
        height: 60px;
        object-fit: contain;
        margin: 10px 0;
        filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
    }

    .item-name {
        color: #fff;
        font-size: 12px;
        text-align: center;
        margin: 5px 0 10px;
        word-break: break-word;
        flex-grow: 1;
    }

    .take-btn {
        background: #4CAF50;
        color: white;
        border: none;
        border-radius: 4px;
        padding: 6px 12px;
        font-size: 12px;
        cursor: pointer;
        width: 100%;
        transition: background 0.2s, opacity 0.2s;
        font-weight: bold;
    }

    .take-btn:hover {
        background: #45a049;
    }

    .take-btn:active {
        transform: scale(0.98);
    }

    .loading, .error, .empty {
        grid-column: 1 / -1;
        text-align: center;
        padding: 40px;
        color: #fff;
    }

    .spinner {
        border: 4px solid #3a3a3a;
        border-top: 4px solid #4CAF50;
        border-radius: 50%;
        width: 40px;
        height: 40px;
        animation: spin 1s linear infinite;
        margin: 0 auto 20px;
    }

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }

    .error p {
        color: #ff4444;
        margin-bottom: 15px;
    }

    .retry-btn {
        background: #4CAF50;
        color: white;
        border: none;
        border-radius: 4px;
        padding: 8px 16px;
        cursor: pointer;
        font-size: 14px;
    }

    .retry-btn:hover {
        background: #45a049;
    }

    .empty p {
        color: #888;
        font-size: 16px;
    }

    /* Стилизация скроллбара */
    .items-container::-webkit-scrollbar {
        width: 8px;
    }

    .items-container::-webkit-scrollbar-track {
        background: #2a2a2a;
    }

    .items-container::-webkit-scrollbar-thumb {
        background: #4a4a4a;
        border-radius: 4px;
    }

    .items-container::-webkit-scrollbar-thumb:hover {
        background: #5a5a5a;
    }
</style>